import { useEffect, useState } from 'react';
import { getFocus, useGet } from 'state/jotai';
import { _seasons_isometry } from 'state/store.season';
import { active_project } from 'state/store.global';
import { getIsoData, getSeasonIsoData } from 'state/jotai.isometryDataHooks';

export const SeasonsPlay = ({ frame, setFrame, config }) => {
  const min = config.FIRST_IMAGE;
  const max = config.LAST_IMAGE;
  const totalImages = max - min + 1; // Total number of images
  const imagesPerSecond = 30; // Desired playback speed: 3 images per second
  const frameInterval = 1000 / imagesPerSecond; // Time per image in milliseconds

  const { pin, pid } = useGet(active_project);
  const season = getFocus(_seasons_isometry, 'season_type');
  const activeIsometryFrame = getIsoData("activeframe");
  const season_activeIsometryFrame = getSeasonIsoData("activeframe");
  const seasonType = season?.[pin]?.[pid]?.[activeIsometryFrame]?.type;

  useEffect(() => {
    let currentFrame = frame; // Start from the initial frame

    const interval = setInterval(() => {
      const nextFrame = currentFrame + 1 > max ? min : currentFrame + 1; // Loop back to min if max is exceeded
      currentFrame = nextFrame;

      const updatedFrame = {
        ...season_activeIsometryFrame,
        [activeIsometryFrame]: {
          ...season_activeIsometryFrame[activeIsometryFrame],
          [seasonType]: nextFrame,
        },
      };

      setFrame(updatedFrame);
    }, frameInterval);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [min, max, frameInterval, seasonType]);

  return null;
};
